<script lang="ts">
  import { push } from 'svelte-spa-router';
  import Table from '../../Table.svelte';
  import type { RecentPendingPayout } from '../../../lib/api/admin/dashboard.service';
  import { formatDate } from '../../../lib/utils/formatters';

  export let payouts: RecentPendingPayout[] = [];
  export let loading = false;
  export let error: string | null = null;

  const columns = [
    {
      key: 'employer_name',
      label: 'Employer',
      width: '28%',
      mobilePrimary: true,
      render: (value: string) => `<span class="employer-name">${value}</span>`
    },
    {
      key: 'charity_name',
      label: 'Charity',
      width: '28%',
      render: (value: string) => `<span class="charity-name">${value}</span>`
    },
    {
      key: 'amount',
      label: 'Amount',
      width: '22%',
      render: (value: number) =>
        `<span class="amount-value">${formatCurrency(value)}</span>`
    },
    {
      key: 'payment_date',
      label: 'Employer paid',
      width: '22%',
      render: (value: string | null) =>
        `<span class="date-value">${value ? formatDate(value) : '—'}</span>`
    }
  ];

  function formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  function handleRowClick(row: RecentPendingPayout) {
    if (row?.employer_payment_uuid) {
      push(`/admin/payments/received/${row.employer_payment_uuid}`);
    }
  }
</script>

{#if loading}
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading pending payouts...</p>
  </div>
{:else if error}
  <div class="error-container">
    <p class="error-message">{error}</p>
  </div>
{:else}
  <Table
    actionText="View All"
    actionHref="#/admin/pending-payouts"
    {columns}
    data={payouts}
    onRowClick={handleRowClick}
  />
{/if}

<style>
  .loading-container,
  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    text-align: center;
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    padding: 2rem;
  }

  .loading-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e5e7eb;
    border-left-color: var(--color-primary, #ffb400);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 0.75rem;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .error-message {
    color: #ef4444;
    margin: 0;
  }

  :global(.amount-value) {
    font-weight: 600;
    color: #111827;
  }
</style>
